import {
	GoogleAnalyticsEventCategory,
	GoogleAnalyticsEventAction,
	GoogleAnalyticsEventLabel
} from './enums';
import { CookieService } from '@nbg-globals/cookie';

declare const ga: any;

export class GoogleAnalyticsUtils {
	static sendContinueEvent() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.Continue,
			GoogleAnalyticsEventLabel.Continue
		);
	}

	static sendLoginEvent() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.Login,
			GoogleAnalyticsEventLabel.Login
		);
	}

	static sendCreatePasswordStep1() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.CreatePassword,
			GoogleAnalyticsEventLabel.CreatePasswordStep1
		);
	}
	static sendCreatePasswordStep2() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.CreatePassword,
			GoogleAnalyticsEventLabel.CreatePasswordStep2
		);
	}

	static sendCreatePasswordStep3() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.CreatePassword,
			GoogleAnalyticsEventLabel.CreatePasswordStep3
		);
	}

	static sendRetrievePasswordStep1() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.RetrievePassword,
			GoogleAnalyticsEventLabel.RetrievePasswordStep1
		);
	}

	static sendRetrievePasswordStep2() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.RetrievePassword,
			GoogleAnalyticsEventLabel.RetrievePasswordStep2
		);
	}

	static sendRetrievePasswordStep3() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.RetrievePassword,
			GoogleAnalyticsEventLabel.RetrievePasswordStep3
		);
	}

	static sendRetrievePasswordStep4() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.RetrievePassword,
			GoogleAnalyticsEventLabel.RetrievePasswordStep4
		);
	}

	static sendRetrievePasswordStep5() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.RetrievePassword,
			GoogleAnalyticsEventLabel.RetrievePasswordStep5
		);
	}

	static sendSocialNetworkFb() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.SocialNetworks,
			GoogleAnalyticsEventLabel.Facebook
		);
	}

	static sendSocialNetworkTwitter() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.SocialNetworks,
			GoogleAnalyticsEventLabel.Twitter
		);
	}

	static sendSocialNetworkYouTube() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.SocialNetworks,
			GoogleAnalyticsEventLabel.YouTube
		);
	}

	static sendSocialNetworkLinkedIn() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.SocialNetworks,
			GoogleAnalyticsEventLabel.Linkedin
		);
	}

	static sendSocialNetworkMail() {
		CookieService.runGoogleAnalyticsCommand(
			'send',
			'event',
			GoogleAnalyticsEventCategory.InternetBankingLogin,
			GoogleAnalyticsEventAction.SocialNetworks,
			GoogleAnalyticsEventLabel.Mail
		);
	}
}
